import {
  Config,
  createBeaconPlugin,
  createCookiePlugin,
  createCustomEventsPlugin,
  createFeaturesPlugin,
  createFingerprintPlugin,
  createPageViewPlugin,
  createPersistentIdPlugin,
  createReferralApiPlugin,
  createReferrerCodePlugin,
  createScreenResolutionPlugin,
  createSdkPlugin,
  createSessionIdPlugin,
  createTimestampPlugin,
  createWalletConnectsPlugin,
} from "@spindl-xyz/sdk-core";
import { createMetadataPlugin } from "@spindl-xyz/sdk-core/plugins/metadata";

const VERSION: string = "__VERSION__";
const sdk = createSdkPlugin({ sdkKey: "" }, VERSION);

const metadata = createMetadataPlugin([
  createSessionIdPlugin,
  createReferrerCodePlugin,
  createPersistentIdPlugin,
  createFingerprintPlugin,
  createCookiePlugin,
  createScreenResolutionPlugin,
  createFeaturesPlugin,
  createTimestampPlugin,
]);

const beacon = createBeaconPlugin(sdk, metadata);

export const { pageView, enableAutoPageViews } = createPageViewPlugin(beacon);
export const { attribute, enableAutoWalletConnects } =
  createWalletConnectsPlugin(beacon);
export const {
  checkReferrerCode,
  createReferrerCode,
  getReferrerAddress,
  getReferrerAttribution,
  getReferrerHistory,
  getReferrerStats,
  getReferrerCode,
  validateReferrerCode,
} = createReferralApiPlugin(sdk, metadata);
export const { track } = createCustomEventsPlugin(beacon);

export function configure(initialConfig: Config) {
  sdk.setConfig(initialConfig);
}
